"use strict";

exports.__esModule = true;
exports.FlexRow = void 0;
var _react = _interopRequireDefault(require("react"));
var _excluded = ["rowComponent", "cellComponent", "width", "height", "gutter", "style", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Renders children in a row using a simple flexbox-like algorithm.
 * Each child may specify a `flex` prop which determines the width of
 * that child relative to other elements in the row.
 */
var FlexRow = exports.FlexRow = /*#__PURE__*/function (_React$PureComponent) {
  function FlexRow() {
    return _React$PureComponent.apply(this, arguments) || this;
  }
  _inheritsLoose(FlexRow, _React$PureComponent);
  var _proto = FlexRow.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      RowComponent = _this$props.rowComponent,
      CellComponent = _this$props.cellComponent,
      width = _this$props.width,
      height = _this$props.height,
      gutter = _this$props.gutter,
      style = _this$props.style,
      children = _this$props.children,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var kids = _react["default"].Children.toArray(children);
    var totalFlex = 0;
    for (var i = 0; i < kids.length; i++) {
      var child = kids[i];
      totalFlex += getFlexValue(child);
    }
    var modifiedChildren = [];
    var availableWidth = Math.floor((width - (kids.length - 1) * gutter) / 16) * 16;
    var flexWidth = availableWidth / totalFlex;
    var x = 0;
    var y = 0;
    for (var _i = 0; _i < kids.length; _i++) {
      var _child = kids[_i];
      if (CellComponent) {
        modifiedChildren.push(/*#__PURE__*/_react["default"].createElement(CellComponent, {
          key: _i,
          x: x,
          y: y,
          width: flexWidth * getFlexValue(_child),
          height: height
        }, _child));
      } else {
        modifiedChildren.push(/*#__PURE__*/_react["default"].cloneElement(_child, {
          x: x,
          y: y,
          width: flexWidth * getFlexValue(_child),
          height: height,
          flex: undefined
        }));
      }
      x += Math.floor(flexWidth * getFlexValue(_child)) + gutter;
    }
    return /*#__PURE__*/_react["default"].createElement(RowComponent, _extends({}, extra, {
      style: Object.assign({
        width: width,
        height: height
      }, style)
    }), modifiedChildren);
  };
  return FlexRow;
}(_react["default"].PureComponent);
FlexRow.defaultProps = {
  rowComponent: "div",
  gutter: 0
};
function getFlexValue(input) {
  if (typeof input.props.flex === "number") {
    return input.props.flex || 1;
  } else if (input.props.element != null && input.props.element.props != null) {
    return input.props.element.props.flex || 1;
  }
  return 1;
}